import { render, staticRenderFns } from "./RemarkBlock.vue?vue&type=template&id=c1ae6092&"
import script from "./RemarkBlock.vue?vue&type=script&lang=ts&"
export * from "./RemarkBlock.vue?vue&type=script&lang=ts&"
import style0 from "./RemarkBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1ae6092')) {
      api.createRecord('c1ae6092', component.options)
    } else {
      api.reload('c1ae6092', component.options)
    }
    module.hot.accept("./RemarkBlock.vue?vue&type=template&id=c1ae6092&", function () {
      api.rerender('c1ae6092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/RemarkBlock.vue"
export default component.exports